import styled, { createGlobalStyle } from 'styled-components';
import { BarihausLayout } from '@bancobarigui/barihaus';

export const UserDropdownGlobalStyle = createGlobalStyle`
  .user-dropdown-menu,
  .user-dropdown-menu .ant-dropdown,
  .user-dropdown-menu .ant-dropdown-menu-root {
    width: 116px !important;
    min-width: 116px !important;
  }

  .user-dropdown-menu .ant-dropdown-menu {
    padding: 8px;
    border-radius: 8px;
  }

  .user-dropdown-menu .ant-dropdown-menu-item {
    padding: 4px 8px;
    border-radius: 4px;
    height: 32px;
    display: flex;
    align-items: center;

    &:hover {
      background-color: var(--colors-neutral-fill-colorfilltert, rgba(0, 0, 0, 0.04));
    }
  }
`;

export const UserName = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: var(--colors-neutral-text-colortext-dark, #262626);
`;

export const UserIconButton = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: var(--colors-base-blue-700, #0090FF);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const UserMenuItemLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 8px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: var(--colors-neutral-text-colortext-dark, #000);

  svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
`;

export const UserTrigger = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  height: 100vh;
`;

export const StyledContent = styled.div`
  flex-direction: column;
  flex: 1;
  max-width: 100%;
`;

export const StyledBarihausLayout = styled(BarihausLayout)`
  && {
    .ant-layout-sider {
      height: 100vh;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }

    .ant-layout-sider-children {
      display: flex;
      flex-direction: column;
      height: 100%;
      overflow: hidden;
    }

    .ant-menu {
      flex: 1;
      overflow-y: auto;
      overflow-x: hidden;
      height: 100%;

      &::-webkit-scrollbar {
        width: 8px;
        display: block;
      }

      &::-webkit-scrollbar-track {
        background: transparent;
      }

      &::-webkit-scrollbar-thumb {
        background: var(--colors-neutral-text-colortextsec-dark);
        border-radius: 4px;
      }

      &::-webkit-scrollbar-thumb:hover {
        background: var(--colors-neutral-text-colortextsec-dark);
      }

      scrollbar-width: thin;
      scrollbar-color: var(--colors-neutral-text-colortextsec-dark);
    }

    .ant-menu:not(.ant-menu-inline-collapsed) {
      .ant-menu-item,
      .ant-menu-submenu-title {
        .ant-menu-title-content {
          font-size: var(--components-menu-global-fontsize, 16px);
          font-weight: var(--typography-fontweight-fontweightregular, 400);
          line-height: var(--components-menu-global-lineheight, 24px);
        }

        svg {
          margin-right: 24px;
          width: var(--components-menu-component-iconsize, 24px);
          height: var(--components-menu-component-iconsize, 24px);
        }
      }

    }

    .ant-menu-inline-collapsed {
      .ant-menu-item,
      .ant-menu-submenu-title {
        padding: 0 !important;
        display: flex;
        justify-content: center;
        align-items: center;

        .ant-menu-item-icon {
          margin: 0;
        }

        .ant-menu-title-content {
          display: none;
        }

        svg {
          margin: 0;
          width: var(--components-menu-component-iconsize, 24px);
          height: var(--components-menu-component-iconsize, 24px);
        }
      }
    }

    .ant-breadcrumb-link-clickable {
      color: var(--colors-neutral-text-colortextsec-dark);
    }

    /* BarihausLayout always renders a breadcrumb header after the TopBar — hide it since no screen uses breadcrumbs */
    .ant-layout-header + .ant-layout-header {
      display: none;
    }
  }
`;
